<app-dialog>
  <div header>Settings</div>
  <div content>
    <p style="font-weight: bold;">Appearance</p>
    <div style="display: flex; flex-direction: column; gap: 5px; border-radius: 4px; padding: 4px; background: var(--theme-entry-background-color);">
      Theme
      <div>
        <fluent-button (click)="changeTheme(themeType.Light)" [disabled]="currentTheme == 'light'">Light</fluent-button>
        <fluent-button (click)="changeTheme(themeType.Dark)" [disabled]="currentTheme == 'dark'">Dark</fluent-button>
      </div>
      <fluent-divider />
      Tray icon
      <div>
        <fluent-switch [checked]="config?.useTrayIcon" (change)="changedTray($event)">
          <span slot="checked-message">On</span>
          <span slot="unchecked-message">Off</span>
        </fluent-switch>
      </div>
      <fluent-divider />
      Zoom-Level
      <div>
        <fluent-select title="Select a section" (change)="changed($event)" value="{{config?.zoomFactor}}" style="width: 100%; min-width: 100%;">
          <fluent-option value="0.75">75%</fluent-option>
          <fluent-option value="1">100%</fluent-option>
          <fluent-option value="1.25">125%</fluent-option>
          <fluent-option value="1.5">150%</fluent-option>
        </fluent-select>
      </div>
    </div>

    <p style="font-weight: bold;">Location</p>
    <div style="display: flex; flex-direction: column; gap: 5px; border-radius: 4px; padding: 4px; background: var(--theme-entry-background-color);">
      Call History
      <div style="display: grid; grid-template-columns: auto min-content;">
        <fluent-text-field appearance="outline" placeholder="{{config?.callHistoryPath}}" disabled></fluent-text-field>
        <fluent-button (click)="openPath(config!.callHistoryPath)">Open</fluent-button>
      </div>
      <fluent-divider />
      Logs
      <div style="display: grid; grid-template-columns: auto min-content;">
        <fluent-text-field appearance="outline" placeholder="{{config?.logPath}}" disabled></fluent-text-field>
        <fluent-button (click)="openPath(config!.logPath)">Open</fluent-button>
      </div>
    </div>
  </div>
  <fluent-button appearance="accent" (click)="saveSetting()" actions>Save</fluent-button>
  <fluent-button (click)="close()" actions>Close</fluent-button>
</app-dialog>